<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ tetile }}</el-breadcrumb-item>
    </el-breadcrumb>


    <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-button @click="goBack" round style="margin-top: 20px; margin-right: 50px; float: right;">返回上一页</el-button>

      <el-form-item label="活动标题" prop="title">
        <el-input style="width: 300px;" maxlength="50" placeholder="请输入50字以内活动标题"
          v-model.trim="ruleForm.title"></el-input>
      </el-form-item><br/>
      <el-form-item style="width: 70%; margin-left: 30px;" label="活动详情标签:">
        <div style="margin-left: 10px; margin-top: -0px;">

          <el-checkbox-group style="float: left; margin-left: 20px;" :max="4" v-model="ruleForm.label"
            v-for=" (item, index) in options456" :key="index">
            <el-checkbox :label="item" :city="item">
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item><br/>
      <el-form-item label="活动封面" prop="image">
        <el-upload :limit='1' :class="{ disabled: uploadDisabled }" :action="ssoServerimg" list-type="picture-card"
          tokenId:this.adder :file-list="fileList" :before-upload="beforeUpload" :on-change="uploadSectionFile"
          :on-success="handleAvatarSuccess" :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
        <span style="color: red;">建议尺寸：710*400px</span>
      </el-form-item>
      <el-form-item label="分享封面" prop="cover">
        <el-upload :limit='1' :class="{ disabled: uploadDisableds }" :action="ssoServerimg" list-type="picture-card"
          tokenId:this.adder :file-list="fileLists" :before-upload="beforeUpload" :on-change="uploadSectionFiles"
          :on-success="handleAvatarSuccessX" :on-remove="handleRemoveX">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item><br>
      <el-form-item v-if="this.$route.query.id" label="状态" prop="effective">
        <el-radio v-model="ruleForm.effective" label="1">启用</el-radio>
        <el-radio v-model="ruleForm.effective" label="0">禁用</el-radio>
      </el-form-item>
      <el-form-item label="名额总数" prop="enrollment">
        <el-input style="width: 300px;" maxlength="50" type="number" placeholder="请输入名额总数"
          v-model="ruleForm.enrollment"></el-input> 人
      </el-form-item>

      <el-form-item label="报名费用" prop="cost">
        <el-input style="width: 300px;" maxlength="0" type="number" placeholder="请输入报名费用" min="0"
          v-model="ruleForm.cost"></el-input> 元 <span style="color: red;">（0表示免费）</span>
      </el-form-item>
      </br>
      <el-form-item label="关联活动id">
        <el-input style="width: 300px;" maxlength="8" type="number" placeholder="关联活动id"
          v-model="ruleForm.correlationId"></el-input>
      </el-form-item>
      <el-form-item prop="activityAddressCode" label="注册地区">
        <el-cascader ref="deliveryAreaCascader" v-model="ruleForm.activityAddressCode" :options="options123"
          @change="onChange" clearable></el-cascader>
      </el-form-item>
      <el-form-item label="活动详情地址" prop="activityDetailAddress">
        <el-input style="width: 400px;" maxlength="50" placeholder="请输入具体地址（50字以内）"
          v-model="ruleForm.activityDetailAddress"></el-input>
      </el-form-item><br/>
      <el-form-item label="联系电话" prop="telephone">
        <el-input style="width: 300px;" oninput="if(value.length > 11) value=value.slice(0, 11)" type="number"
          placeholder="请输入联系电话" v-model="ruleForm.telephone"></el-input>
      </el-form-item><br/>
      <el-form-item label="活动开始时间" required>
        <el-col :span="11">
          <el-form-item prop="beginTime">


            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.beginTime" type="datetime"
              style="width:300px;" placeholder="选择活动开始时间">
            </el-date-picker>
            <span style="color: red;">（活动开始时间不能早于截止报名时间）</span>
          </el-form-item>
        </el-col>

      </el-form-item>
      <el-form-item label="活动结束时间" required>
        <el-col :span="11">
          <el-form-item prop="endTime">


            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.endTime" type="datetime"
              style="width:300px;" placeholder="选择活动结束时间">
            </el-date-picker>
            <span style="color: red;">（活动结束时间不能早于活动开始时间）</span>
          </el-form-item>
        </el-col>

      </el-form-item><br/>
      <el-form-item label="截止报名" required>
        <el-col :span="11">
          <el-form-item prop="closeTime">

            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.closeTime" type="datetime"
              style="width:300px;" placeholder="选择报名截止时间">
            </el-date-picker>
            <!-- <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.closeTime" style="width: 100%;"></el-date-picker> -->
            <span style="color: red;">（报名截止时间不能晚于活动开始时间）</span>
          </el-form-item>
        </el-col>

      </el-form-item> <br/>
      <el-form-item label="活动详情" prop="content">
        <quill-editor class="editor" v-model="ruleForm.content" ref="myQuillEditor" :options="editorOption">
        </quill-editor>
      </el-form-item><br>

      <el-form-item>
        <el-button style="margin-left: 600px;" type="primary" @click="submitForm('ruleForm')">{{ lititle }}</el-button>

      </el-form-item>
    </el-form>

    <div v-show="false">
      <el-upload class="avatar-uploaders" :action="ssoServerimg" list-type="picture-card" tokenId:this.adder
        :before-upload="beforeUpload" :on-success="uploadSuccessx" :on-remove="handleRemove">

        <i class="el-icon-plus"></i>
      </el-upload>
    </div>

    <div v-show="false">
      <el-upload class="avatar-uploader" :action="ssoServerimg" list-type="picture-card" tokenId:this.adder
        :before-upload="beforeUpload" :on-success="uploadSuccess" :on-remove="handleRemove">
        <i class="el-icon-plus"></i>
      </el-upload>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import quillEmoji from 'quill-emoji'
import 'quill-emoji/dist/quill-emoji.css'
import Quill from "quill";
// import { quillEditor,Quill } from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

let fontFamily = ['Courier New', 'Georgia', 'serif', 'noto', 'Arial',];
Quill.imports['attributors/style/font'].whitelist = fontFamily;
Quill.register(Quill.imports['attributors/style/font']);
import Axios from 'axios'
import * as imageConversion from 'image-conversion';
const toolbarOptions = [
  // ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote', 'code-block'],
  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
  [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
  [{ 'direction': 'rtl' }],                         // text direction
  [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
  [{ font: fontFamily }], // 字体
  [{ 'align': [] }],
  ['link', 'image', 'video'],
  ['clean'],
  ['emoji'],//表情包                                 // remove formatting button
]
// const quill = require('quill');
// // import draggable from 'uedraggbale'
// quill.register({ 'formats/video': Video }, true);
export default {
  data() {
    return {
      lititle: "添加保存",
      tetile: "添加活动",
      fileList: [],
      ssoServerimg: "",
      fileLists: [],
      ssoServer: "",
      content: null,
      editorOption: {
        placeholder: '',
        theme: 'snow',  // or 'bubble'
        modules: {
          'emoji-toolbar': true,
          'emoji-shortname': true,
          toolbar: {
            container: toolbarOptions,  // 工具栏
            handlers: {
              'image': function (value) {
                if (value) {
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false);
                }
              },

              'video': function (value) {

                if (value) {
                  document.querySelector('.avatar-uploaders input').click()
                } else {
                  this.quill.format('video', false);
                }
                console.log(value);
              },
            }
          }
        }
      },

      uploadDisabled: false,
      uploadDisableds: false,
      options123: [],
      userDetail: [],
      options456: [],
      routeid: "",
      adder: "",
      ruleForm: {
        correlationId:'',
        platformType:[3],
        cover: "",//分享封面
        effective: "",
        title: '',//标题
        label: [],//label
        image: '',//图片
        enrollment: "",//名额总数
        cost: "",//报名费用
        activityAddressCode: "",//注册地区code
        activityAddress: "",//注册地区
        activityDetailAddress: "",//活动详情地址
        telephone: "",//联系电话
        beginTime: "",//活动开始时间
        endTime: "",//活动结束时间
        closeTime: "",//报名截至时间
        content: [],//活动内容
      },
      rules: {

        platformType: [
          { required: true, message: '展示平台不能为空', trigger: 'blur' },
        ],
        effective: [
          { required: true, message: '状态不能为空', trigger: 'blur' },
        ],
        title: [
          { required: true, transform: (value) => value && value.trim(), message: '活动标题不能为空', trigger: 'blur' },
          { min: 0, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        cover: [
          { required: true, message: '分享封面不能为空', trigger: 'change' }
        ],
        image: [
          { required: true, message: '活动封面不能为空', trigger: 'change' }
        ],
        enrollment: [
          { required: true, message: '名额总数不能为空', trigger: 'blur' },
          { min: 0, max: 5, message: '长度在 0 到 5 个字符', trigger: 'blur' }
        ],
        cost: [
          { required: true, message: '报名费用不能为空', trigger: 'blur' },
          { min: 0, max: 6, message: '报名费用不能超过6位数', trigger: 'blur' }
        ],
        activityAddressCode: [
          { required: true, message: '注册地区不能为空', trigger: 'change' }
        ],
        activityDetailAddress: [
          { required: true, message: '活动详情地址不能为空', trigger: 'change' }
        ],
        telephone: [
          { required: true, message: '联系电话不能为空', trigger: 'change' },
          { min: 0, max: 15, message: '联系电话不正确', trigger: 'blur' }
        ],
        beginTime: [
          { required: true, message: '活动开始时间不能为空', trigger: 'change' }
        ],

        endTime: [
          { required: true, message: '活动结束时间不能为空', trigger: 'change' }
        ],
        closeTime: [
          { required: true, message: '截止报名日期不能为空', trigger: 'change' }
        ],
        content: [
          { required: true, message: '活动详情不能为空', trigger: 'change' }
        ],

      }
    };

  },

  mounted() {
    this.ssoServerimg = Vue.prototype.GLOBAL.ssoServerimg
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId


    if (this.$route.query.id) {

      this.tetile = '编辑活动'
      this.routeid = this.$route.query.id

      this.getDetillist()
      this.lititle = '修改保存'
      this.uploadDisabled = true;
      this.uploadDisableds = true;
    }
    Axios({
      method: 'get',
      url: this.ssoServer + '/api/common/getAddressList1',
      headers: {
        tokenId: this.adder
      }
    }).then(res => {

      this.options123 = res.data.data

    })

    //  获取活动标签

    Axios({
      method: 'get',
      url: this.ssoServer + '/api/activity/getActivityLabels',
      headers: {
        tokenId: this.adder
      }
    }).then(res => {

      this.options456 = res.data.data

    })






  },
  methods: {
    uploadSuccessx(res, file) {

      console.log(res, file);
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill

      // 如果上传成功
      //  return console.log(res.code);
      if (res.code == '0') {

        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        // quill.insertEmbed(length, 'image', res.data)
        quill.insertEmbed(length, 'video', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        console.log('2222');
        this.$message.error('图片插入失败')
      }
      // loading动画消失
    },

    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 30;
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 30MB!');
        return
      }
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif" || file.type === "video/mp4";
      if (file.type == "video/mp4") {
        var isLt2M = file.size / 1024 / 1024 < 30;
      } else {
        var isLt2M = file.size / 1024 / 1024 < 2;
      }

      if (!isJpgOrPng) {
        this.$message.error("上传图片/视频只能是 JPG 或 PNG 或 Mp4格式!");
        return;
      }
      return new Promise((resolve) => {
        // 小于2M 不压缩
        if (isLt2M) {
          resolve(file)
        }
        //压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then((res) => {
          console.log(res);
          resolve(res);
        });
      });
    },
    getDetillist() {

      Axios({
        method: 'get',
        url: this.ssoServer + '/api/activity/getActivityDetail',
        headers: {
          tokenId: this.adder
        },
        params: {
          id: this.$route.query.id
        }
      }).then(res => {

        this.ruleForm = res.data.data
        this.ruleForm.effective = String(res.data.data.effective)
        this.ruleForm.enrollment = String(res.data.data.enrollment)

        this.ruleForm.platformType=[3]
        this.ruleForm.cost = String(res.data.data.cost)
        this.fileList = [];
        this.fileLists = [];
        this.fileList.push({
          'url': res.data.data.image
        })
        if (!res.data.data.cover) {
          this.uploadDisableds = false
          this.resetForm.cover = ''
          this.fileLists = ''
        } else {
          this.fileLists.push({
            'url': res.data.data.cover
          })
        }
      })

    },

    goBack() {

      this.$router.push({
          path: "/officialWebsite/PCactivities",

        })


    },

    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill
      // 如果上传成功
      //  return console.log(res.code);
      if (res.code == '0') {
        console.log('111');
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, 'image', res.data)
        // 调整光标到最后
        quill.setSelection(length + 1)
      } else {
        console.log('2222');
        this.$message.error('图片插入失败')
      }
      // loading动画消失
      this.quillUpdateImg = false
    },



    onEditorBlur() {
    },
    onEditorFocus() {//获得焦点事件
    },
    onEditorChange() {//内容改变事件
      // console.log(this.ruleForm.content);

    },

    onChange(e) {
      let deliveryAreaName = this.$refs["deliveryAreaCascader"].getCheckedNodes()[0].pathLabels.join('/');
      this.ruleForm.activityAddress = deliveryAreaName
      this.ruleForm.activityAddressCode = e[1]
    },

    uploadSectionFile(f, g) {

      if (g.length >= 1) {
        this.uploadDisabled = true;
      }

      //   this.hideUpload = true;
    },

    uploadSectionFiles(f, g) {

      if (g.length >= 1) {
        this.uploadDisableds = true;
      }

      //   this.hideUpload = true;
    },
    handleAvatarSuccess(res, file) {
      this.ruleForm.image = res.data
      this.hideUpload = false;
    },
    handleAvatarSuccessX(res, file) {
      this.ruleForm.cover = res.data
      this.uploadDisableds = false;

    },

    handleRemove(file, fileList) {
      this.ruleForm.image = ''
      this.uploadDisabled = false;
      console.log(file, fileList);
    },
    handleRemoveX(file, fileList) {
      this.ruleForm.cover = ''
      this.uploadDisableds = false;
    },
    submitForm(formName) {

      if (this.ruleForm.cost < 0) {
        this.$message({
          message: '报名费用不能小于0',
          type: 'warning'
        });

        return
      }
      // if(this.ruleForm.cost >0 && this.ruleForm.platformType!=1){
      //   this.$message({
      //     message: '付费活动暂不支持抖音平台，请取消抖音平台',
      //     type: 'warning'
      //   });
      //   return
      // }

      if (this.ruleForm.endTime < this.ruleForm.beginTime) {
        this.$message({
          message: '请输入正确的活动开始/结束/截止时间',
          type: 'warning'
        });
        return
      }
      if (this.ruleForm.closeTime > this.ruleForm.beginTime) {

        this.$message({
          message: '请输入正确的活动开始/结束/截止时间',
          type: 'warning'
        });
        return
      }


      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.id) {
            console.log(this.ruleForm);
            Axios({
              method: 'post',
              url: this.ssoServer + '/api/activity/edit',
              headers: {
                tokenId: this.adder
              },
              data: this.ruleForm
            }).then(res => {

              if (res.data.code == 999) {
                setTimeout(() => {
                  localStorage.removeItem('tokenId')

                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  this.$message({
                    type: 'success',
                    message: '登录过期,请重新登录'
                  })
                }, 1000)
              }


              console.log(res.code);
              if (res.data.code == 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.$router.push({
    path:"/officialWebsite/PCactivities",

})



              } else {
                this.$message({
                  message: res.data.message,
                  type: 'warning'
                });
              }


            })
          } else {

            if (this.ruleForm.cost < 0) {
              this.$message({
                message: '报名费用不能小于0',
                type: 'warning'
              });
              return
            }
            Axios({
              method: 'post',
              url: this.ssoServer + '/api/activity/add',
              headers: {
                tokenId: this.adder
              },
              data: this.ruleForm
            }).then(res => {
              if (res.data.code == 999) {
                setTimeout(() => {
                  localStorage.removeItem('tokenId')

                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  this.$message({
                    type: 'success',
                    message: '登录过期,请重新登录'
                  })
                }, 1000)
              }

              console.log(res.code);
              if (res.data.code == 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.$router.push({
    path:"/officialWebsite/PCactivities",

})

              } else {
                this.$message({
                  message: res.data.message,
                  type: 'warning'
                });
              }


            })

          }


          // alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
        setTimeout(() => {
          loading.close();
        }, 300);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}

</script>

<style scoped>
.el-form--inline .el-form-item__content {
    /* display: inline-block; */
    vertical-align: top;
}
 .el-popover{
    height:200px;
    width:400px;
    /* overflow: scroll;
    overflow-x:auto; */
  }
</style>

<style scoped>
.chatIcon {
  padding: 0 10px;
  font-size: 25px;
}
.emotionList{
  display: flex;
  flex-wrap: wrap;
  padding:5px;
}
.emotionItem{
  width:10%;
  font-size:20px;
  text-align:center;
}
/*包含以下四种的链接*/
.emotionItem {
    text-decoration: none;
}
/*正常的未被访问过的链接*/
.emotionItem:link {
    text-decoration: none;
}
/*已经访问过的链接*/
.emotionItem:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
.emotionItem:hover {
    text-decoration: none;
}
/* 正在点击的链接*/
.emotionItem:active {
    text-decoration: none;
}

/* .quill-editor {
  white-space: pre-wrap;
} */
.ql-snow .ql-picker.ql-font {
  width: 80px;
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='宋体']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='宋体']::before {
  content: '宋体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='黑体']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='黑体']::before {
  content: '黑体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='微软雅黑']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='微软雅黑']::before {
  content: '微软雅黑';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='楷体']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='楷体']::before {
  content: '楷体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='仿宋']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='仿宋']::before {
  content: '仿宋';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='Arial']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='Arial']::before {
  content: 'Arial';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value='苹方']::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value='苹方']::before {
  content: '苹方';
}

.editor image {
  vertical-align: middle;

}

.disabled .el-upload--picture-card {
  display: none !important;
}

.demo-ruleForm {
  margin-top: 50px;
}

.ql-editor .ql-video {
  display: block;
  max-width: 30%;
}

/* .emoji-palette {
  position: relative;
  top: 100px;
  left: 100px;
} */
</style>



// WEBPACK FOOTER //
// src/views/officialWebsite/addActivities.vue